import MuiMenu, { MenuProps as MuiMenuProps } from "@mui/material/Menu";
import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from "@mui/material/MenuItem";
import MuiDivider, { DividerProps as MuiDividerProps } from "@mui/material/Divider";

export type MenuProps = MuiMenuProps;

const Menu: React.FC<MenuProps> = (props) => {
  return <MuiMenu {...props}>{props.children}</MuiMenu>;
};

export interface MenuItemProps extends MuiMenuItemProps {
  actionItem?: boolean;
  size?: "small" | "medium";
}

export const MenuItem: React.FC<MenuItemProps> = (props) => {
  const { actionItem, size = "small", ...rest } = props;
  return (
    <MuiMenuItem
      {...rest}
      sx={{
        ...props?.sx,
        fontSize: size == "small" ? "13px" : "inherit",
        color: actionItem ? "primary.main" : "inherit"
      }}
    >
      {props.children}
    </MuiMenuItem>
  );
};

export type DividerProps = MuiDividerProps;

export const Divider: React.FC<DividerProps> = (props) => {
  return <MuiDivider {...props} />;
};

export default Menu;
